import {Injectable} from '@angular/core';
import {Http, Response, Headers, URLSearchParams} from '@angular/http';
import * as _ from "lodash";
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class PointOfSaleA2Service {

    private baseUrl: string = `../rest/company`;

    constructor(private http : Http) {}

    get(companyId) {
        return this.http.get(`${this.baseUrl}/${companyId}/pointOfSale`)
            .map((res:any) => res.json());
    }

    getOne(companyId, id) {
        return this.http.get(`${this.baseUrl}/${companyId}/pointOfSale/${id}`)
            .map((res:any) => res.json());
    }

    getWithOptionalParams(companyId, fields) {
        let params = new URLSearchParams();
        for (var i in fields){
            params.append(i, fields[i]);
        }
        return this.http.get(`${this.baseUrl}/${companyId}/pointOfSale`, {search: params})
            .map((res:any) => res.json());
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    getBaseUrl(){
        return this.baseUrl;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/core/point-of-sale.service.service.ts